import {validateAndMutateTelephoneFormat} from "../../../helpers/telephone-utils";
import {isValidMail} from "./EmailValidation";
import React from "react";

export interface InputValidatorProps
{
    e: any,
    type: string,
    required: boolean,
    setValidationMessage: React.Dispatch<React.SetStateAction<string>>
    extraData: any
}

const validateTelephoneInput = ( e: any, setValidationMessage: ( value: ((( prevState: string ) => string) | string) ) => void ) => {
    const {valid, value} = validateAndMutateTelephoneFormat( {value: e.target.value} );
    if ( valid ) {
        e.target.value = value;
        setValidationMessage( '' );
    }
    else {
        setValidationMessage( 'leadgeneration.validation.telephone' );
    }
};

const validateEmailInput = ( targetValue: string, extraData: any, setValidationMessage: ( value: ((( prevState: string ) => string) | string) ) => void ) => {
    if ( !isValidMail( targetValue, extraData.invalidDomains ) ) {
        setValidationMessage( 'leadgeneration.validation.email' );
    }
    else {
        setValidationMessage( '' );
    }
};

export const ValidateInput = ( {e, required, type, setValidationMessage, extraData}: InputValidatorProps ) => {
    const targetValue: string = e.target.value.trim();
    if ( required && targetValue === "" ) {
        setValidationMessage( 'leadgeneration.validation.required' )
    }
    else if ( type === 'tel' ) {
        validateTelephoneInput( e, setValidationMessage );
    }
    else if ( extraData.invalidDomains !== undefined && type === 'email' ) {
        validateEmailInput( targetValue, extraData, setValidationMessage );
    }
    else {
        setValidationMessage( '' );
    }
};
